import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDReportsUser_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDReportsUser_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  DeleteFromLocalStorage: string;
  DeleteFromLocalStorage_dummy: string;
  WriteToLocalStorage: any;
  WriteToLocalStorage_dummy: any;
  SelectCustomerWithId: any[];
  SelectCustomerWithId_dummy: any[];
  SelectStationsCountWithId: any[];
  SelectStationsCountWithId_dummy: any[];
  SelectStationsSearchWithId: any[];
  SelectStationsSearchWithId_dummy: any[];
  SelectOrdersCountWithCustomerId: any[];
  SelectOrdersCountWithCustomerId_dummy: any[];
  SelectOrdersWithCustomerId: any[];
  SelectOrdersWithCustomerId_dummy: any[];
  CountForHeaders: any[];
  CountForHeaders_dummy: any[];
  SelectForecastWithCustomerId: any[];
  SelectForecastWithCustomerId_dummy: any[];
  TestChartQuery2: any[];
  TestChartQuery2_dummy: any[];
  ChartQuerySearch: any[];
  ChartQuerySearch_dummy: any[];
  AktifOngorulerTestGrafik: any[];
  AktifOngorulerTestGrafik_dummy: any[];
  ForecastExcelReturner: string;
  ForecastExcelReturner_dummy: string;
  DownloadFile: any;
  DownloadFile_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  GetOrdersExcelForCustomerId: any[];
  GetOrdersExcelForCustomerId_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp926740Visible: "visible" | "hidden";
  isComp218103Visible: "visible" | "hidden";
  isComp983193Visible: "visible" | "hidden";
  isComp536455Visible: "visible" | "hidden";
  isComp818740Visible: "visible" | "hidden";
  isComp835553Visible: "visible" | "hidden";
  isComp705224Visible: "visible" | "hidden";
  isComp323346Visible: "visible" | "hidden";
  isComp25372Visible: "visible" | "hidden";
  isComp17520Visible: "visible" | "hidden";
  isComp980465Visible: "visible" | "hidden";
  isComp915933Visible: "visible" | "hidden";
}

export class STDReportsUser_ScreenBase extends React.PureComponent<
  ISTDReportsUser_ScreenProps,
  any
> {
  stdreportsuser_521847_value_kuikaTableRef: React.RefObject<any>;
  stdreportsuser_892266_value_kuikaTableRef: React.RefObject<any>;
  stdreportsuser_491983_value_kuikaPaginationRef: React.RefObject<any>;
  stdreportsuser_294671_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "97768397-d105-46f6-abdd-511f9441192f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 491420, PropertyName: "value", Value: "İstasyon" },
        { Id: 977713, PropertyName: "value", Value: "KLT Sayısı" },
        { Id: 898267, PropertyName: "value", Value: "Beklenen Siparişler" },
        { Id: 675406, PropertyName: "value", Value: "Tamamlanan Sipariş" },
        { Id: 646225, PropertyName: "value", Value: "İstasyonlar" },
        { Id: 416063, PropertyName: "placeholder", Value: "Ara..." },
        { Id: 909895, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 876167, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 594764, PropertyName: "title", Value: "Lokasyon" },
        {
          Id: 620312,
          PropertyName: "value",
          Value: "[datafield:stationlocation]",
        },
        { Id: 106289, PropertyName: "title", Value: "Adres" },
        {
          Id: 779525,
          PropertyName: "value",
          Value: "[datafield:stationaddress]",
        },
        { Id: 26149, PropertyName: "title", Value: "Oluşturulma Tarihi" },
        { Id: 833864, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 258376, PropertyName: "title", Value: "Güncellenme Tarihi" },
        { Id: 475243, PropertyName: "value", Value: "[datafield:updatedat]" },
        { Id: 746013, PropertyName: "title", Value: "Durum" },
        { Id: 778698, PropertyName: "value", Value: "Aktif Öngörüler" },
        { Id: 670938, PropertyName: "placeholder", Value: "Ara..." },
        { Id: 750518, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 357822, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 885753, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 80392, PropertyName: "title", Value: "Ürün Kodu" },
        {
          Id: 455275,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 395547, PropertyName: "title", Value: "Ürün Adı" },
        {
          Id: 721822,
          PropertyName: "value",
          Value: "[datafield:customerproductname]",
        },
        { Id: 846935, PropertyName: "title", Value: "Öngörülen Adet" },
        {
          Id: 651211,
          PropertyName: "value",
          Value: "[datafield:forecastquantity]",
        },
        { Id: 419062, PropertyName: "title", Value: "Tamamlanan Adet" },
        {
          Id: 923810,
          PropertyName: "value",
          Value: "[datafield:totalorderedquantity]",
        },
        { Id: 773324, PropertyName: "title", Value: "Tamamlanma Oranı" },
        {
          Id: 555170,
          PropertyName: "value",
          Value: "[datafield:completionpercentage]",
        },
        {
          Id: 384285,
          PropertyName: "value",
          Value: "Aktif Öngörüler Grafiksel Gösterim",
        },
        {
          Id: 893223,
          PropertyName: "placeholder",
          Value: "Ürün Kodu / Ürün Adı / İstasyon Adı ile Ara...",
        },
        { Id: 771346, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 255594, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 846000, PropertyName: "value", Value: "Tamamlanan Adet" },
        { Id: 436321, PropertyName: "value", Value: "Tamamlanan Adet" },
        { Id: 619472, PropertyName: "value", Value: "Siparişler" },
        { Id: 320045, PropertyName: "placeholder", Value: "Ara..." },
        { Id: 926654, PropertyName: "label", Value: "Excel Oluştur" },
        { Id: 756642, PropertyName: "title", Value: "Malzeme Kodu" },
        {
          Id: 782832,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 924565, PropertyName: "title", Value: "Malzeme Kodu" },
        {
          Id: 796863,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 955734, PropertyName: "title", Value: "STenco Malzeme Kodu" },
        { Id: 744145, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 73691, PropertyName: "title", Value: "STenco Malzme Tanımı" },
        { Id: 255760, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 331925, PropertyName: "title", Value: "Kutu İçi Adet" },
        {
          Id: 314063,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 940598, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 469700, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 553586, PropertyName: "title", Value: "Oluşturma Tarihi" },
        { Id: 430282, PropertyName: "value", Value: "[datafield:createdate]" },
        { Id: 841469, PropertyName: "title", Value: "Sipariş No" },
        { Id: 517149, PropertyName: "value", Value: "[datafield:saporderid]" },
        { Id: 634593, PropertyName: "title", Value: "Sipariş Durum" },
        { Id: 323346, PropertyName: "value", Value: "Kısmi Tamamlandı" },
        { Id: 25372, PropertyName: "value", Value: "Bekliyor" },
        { Id: 17520, PropertyName: "value", Value: "Tamamlanmadı" },
        { Id: 980465, PropertyName: "value", Value: "Tamamlandı" },
        {
          Id: 915933,
          PropertyName: "value",
          Value: "[datafield:siparisdurum]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdreportsuser_416063_value_kuikaTextInputRef = React.createRef();
    this.stdreportsuser_521847_value_kuikaTableRef = React.createRef();
    this.stdreportsuser_670938_value_kuikaTextInputRef = React.createRef();
    this.stdreportsuser_892266_value_kuikaTableRef = React.createRef();
    this.stdreportsuser_893223_value_kuikaTextInputRef = React.createRef();
    this.stdreportsuser_491983_value_kuikaPaginationRef = React.createRef();
    this.stdreportsuser_320045_value_kuikaTextInputRef = React.createRef();
    this.stdreportsuser_294671_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Logout: false,
      goToSignInActivity: "",
      DeleteFromLocalStorage: "",
      WriteToLocalStorage: "",
      SelectCustomerWithId: [],
      SelectStationsCountWithId: [],
      SelectStationsSearchWithId: [],
      SelectOrdersCountWithCustomerId: [],
      SelectOrdersWithCustomerId: [],
      CountForHeaders: [],
      SelectForecastWithCustomerId: [],
      TestChartQuery2: [],
      ChartQuerySearch: [],
      AktifOngorulerTestGrafik: [],
      ForecastExcelReturner: "",
      DownloadFile: "",
      ChangeVisibilityOf: "",
      GetOrdersExcelForCustomerId: [],
      ExportExcel: "",
      NAVIGATE: "",
      isComp926740Visible: "visible",
      isComp218103Visible: "hidden",
      isComp983193Visible: "hidden",
      isComp536455Visible: "visible",
      isComp818740Visible: "hidden",
      isComp835553Visible: "hidden",
      isComp705224Visible: "hidden",
      isComp323346Visible: "hidden",
      isComp25372Visible: "hidden",
      isComp17520Visible: "hidden",
      isComp980465Visible: "hidden",
      isComp915933Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdreportsuser", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDReportsUserPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdreportsuser", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdreportsuser", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDReportsUserPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdreportsuser_818740_value:
        this.state.SelectCustomerWithId?.at?.(0)?.customerLogo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDReportsUserPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DeleteFromLocalStorage =
      await ReactSystemFunctions.deleteFromLocalStorage(
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.WriteToLocalStorage =
      await ReactSystemFunctions.writeToLocalStorage(
        ReactSystemFunctions.getMyUsername(),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDReportsUserPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerProductCode_7: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CustomerId_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductCode_9: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_9: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_9: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_9: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectCustomerWithId = result?.data.selectCustomerWithId;
    formVars.stdreportsuser_818740_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].customerLogo
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].customerLogo
        : null
    );
    formVars.stdreportsuser_818740_placeholderimage = "";
    formVars.stdreportsuser_982360_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].name
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].name
        : null
    );
    stateVars.isComp818740Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectCustomerWithId !== undefined
            ? stateVars.SelectCustomerWithId?.length > 0
              ? stateVars.SelectCustomerWithId[0].customerLogo
              : null
            : this.state.SelectCustomerWithId?.length > 0
            ? this.state.SelectCustomerWithId[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    stateVars.SelectOrdersCountWithCustomerId =
      result?.data.selectOrdersCountWithCustomerId;
    stateVars.SelectOrdersWithCustomerId =
      result?.data.selectOrdersWithCustomerId;

    stateVars.CountForHeaders = result?.data.countForHeaders;
    formVars.stdreportsuser_38980_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].stationCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].stationCount
        : null
    );
    formVars.stdreportsuser_101411_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].boxCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].boxCount
        : null
    );
    formVars.stdreportsuser_890896_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].bekleyenSiparisler
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].bekleyenSiparisler
        : null
    );
    formVars.stdreportsuser_712246_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].completedOrderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].completedOrderCount
        : null
    );
    stateVars.SelectForecastWithCustomerId =
      result?.data.selectForecastWithCustomerId;
    stateVars.TestChartQuery2 = result?.data.testChartQuery2;
    stateVars.ChartQuerySearch = result?.data.chartQuerySearch;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdreportsuser_818740_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].customerLogo
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].customerLogo
        : null
    );

    stateVars.isComp818740Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectCustomerWithId !== undefined
            ? stateVars.SelectCustomerWithId?.length > 0
              ? stateVars.SelectCustomerWithId[0].customerLogo
              : null
            : this.state.SelectCustomerWithId?.length > 0
            ? this.state.SelectCustomerWithId[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stdreportsuser_982360_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].name
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].name
        : null
    );

    formVars.stdreportsuser_38980_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].stationCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].stationCount
        : null
    );

    formVars.stdreportsuser_101411_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].boxCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].boxCount
        : null
    );

    formVars.stdreportsuser_890896_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].bekleyenSiparisler
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].bekleyenSiparisler
        : null
    );

    formVars.stdreportsuser_712246_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].completedOrderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].completedOrderCount
        : null
    );

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;
    stateVars.isComp835553Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_521847_value",
          "stationStatus"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp705224Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_521847_value",
          "stationStatus"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_892266 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;
    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    stateVars.dataSource_294671 =
      stateVars.SelectOrdersWithCustomerId ??
      this.state.SelectOrdersWithCustomerId;
    stateVars.isComp323346Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp25372Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp17520Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp980465Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDReportsUserComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_416063_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_416063_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUserComponent_416063_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_416063_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_416063_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_416063_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_416063_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_416063_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_670938_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerProductCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_670938_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChartQuerySearch = result?.data.chartQuerySearch;

    stateVars.TestChartQuery2 = result?.data.testChartQuery2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUserComponent_670938_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_670938_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_892266 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_750518_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_750518_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ForecastExcelReturner = result?.data.forecastExcelReturner;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_750518_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_750518_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(this, this.state.ForecastExcelReturner),
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectCustomerWithId !== undefined
          ? stateVars.SelectCustomerWithId?.length > 0
            ? stateVars.SelectCustomerWithId[0].name
            : null
          : this.state.SelectCustomerWithId?.length > 0
          ? this.state.SelectCustomerWithId[0].name
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_893223_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_893223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_893223_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUserComponent_893223_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_893223_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_634600_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_893223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_634600_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_634600_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_634600_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_491983_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_491983_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUserComponent_491983_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_491983_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_771346_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_771346_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_771346_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_771346_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp926740Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp218103Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983193Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp536455Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_255594_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_255594_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_255594_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_255594_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp218103Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp926740Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_846000_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_846000_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_846000_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_846000_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp536455Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983193Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp218103Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp926740Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_436321_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_491983_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_436321_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifOngorulerTestGrafik = result?.data.aktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUserComponent_436321_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_436321_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983193Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp536455Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.stdreportsuser_491983_total = ReactSystemFunctions.value(
      this,
      stateVars.AktifOngorulerTestGrafik !== undefined
        ? stateVars.AktifOngorulerTestGrafik?.length > 0
          ? stateVars.AktifOngorulerTestGrafik[0].totalCount
          : null
        : this.state.AktifOngorulerTestGrafik?.length > 0
        ? this.state.AktifOngorulerTestGrafik[0].totalCount
        : null
    );

    stateVars.dataSource_855807 =
      stateVars.AktifOngorulerTestGrafik ?? this.state.AktifOngorulerTestGrafik;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_320045_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_320045_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectOrdersWithCustomerId =
      result?.data.selectOrdersWithCustomerId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUserComponent_320045_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUserComponent_320045_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_294671 =
      stateVars.SelectOrdersWithCustomerId ??
      this.state.SelectOrdersWithCustomerId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_926654_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsuser_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetOrdersExcelForCustomerId),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUser/STDReportsUserComponent_926654_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersExcelForCustomerId =
      result?.data.getOrdersExcelForCustomerId;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDReportsUserComponent_323346_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUser",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "962389",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_25372_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUser",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "770386",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_17520_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUser",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "923969",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUserComponent_980465_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsuser_294671_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUser",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "881119",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [962389, 770386, 923969, 881119] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDReportsUser"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDReportsUserPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDReportsUserPageInit();
    }
  }
}
